import React from 'react';
import PropTypes from 'prop-types';
import Input from '../../../../../components/Input';
import TrashIcon from '../../../../../components/Iconoclast/TrashIcon';
import Styles from '../../../../../assets/styles/globals.scss';

const ProjectTypeName = ({
  editingName,
  editProjectType,
  project_type,
  projectTypeExist,
  handleNameChange,
  handleInputClick,
  handleEditKeyDown,
  handleSetTitleElement,
  handleProjectTypeUpdate,
  handleDeleteProjectType,
  handleEditProjectType,
  nameEditRef,
}) => {
  if (editingName) {
    return (
      <div className="project-type-edit" ref={nameEditRef}>
        <div className="project-type-edit-name-container">
          <Input 
            className="project-type-edit-name" 
            value={editProjectType.name} 
            onChange={handleNameChange} 
            onClick={handleInputClick}
            onKeyDown={handleEditKeyDown} 
            ref={handleSetTitleElement} 
          />
        </div>
        <div 
          className={`update-project ${projectTypeExist ? 'hidden' : ''}`} 
          onClick={handleProjectTypeUpdate} 
        />
        <div onClick={handleDeleteProjectType}>
          <TrashIcon fillColor={Styles.white} />
        </div>
      </div>
    );
  }

  return (
    <div className="project-type-title">
      <div className='project-type-text'>{project_type.name.toUpperCase()}</div>
      <div className='edit-pencil' onClick={handleEditProjectType}/>
    </div>
  );
};

ProjectTypeName.propTypes = {
  editingName: PropTypes.bool.isRequired,
  editProjectType: PropTypes.object,
  project_type: PropTypes.object.isRequired,
  projectTypeExist: PropTypes.bool,
  handleNameChange: PropTypes.func.isRequired,
  handleInputClick: PropTypes.func.isRequired,
  handleEditKeyDown: PropTypes.func.isRequired,
  handleSetTitleElement: PropTypes.func.isRequired,
  handleProjectTypeUpdate: PropTypes.func.isRequired,
  handleDeleteProjectType: PropTypes.func.isRequired,
  handleEditProjectType: PropTypes.func.isRequired,
  nameEditRef: PropTypes.object,
};

export default ProjectTypeName;



// WEBPACK FOOTER //
// ./src/containers/ProjectTemplatesContainer/ProjectTypesNav/ProjectTypeNavCard/components/ProjectTypeName.js